<div fxLayoutGap="4px" fxLayout="column" class="w-100 input-field-parent select">
    <span>{{ Utils.getValueFromTranslation(customFieldForm.value.name, localeId) }}</span>
    <mat-form-field class="role-field">
        <mat-label>{{ Utils.getValueFromTranslation(customFieldForm.value.placeholder, localeId) }}</mat-label>
        <mat-select fxFlex="1 1 100%" [formControl]="customFieldForm.get('value') | cast">
            <mat-option *ngFor="let option of customFieldForm.value.options" [value]="option.id">{{
                Utils.getValueFromTranslation(option.value, localeId)
            }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
